module.exports = __webpack_public_path__ + "static/media/C020.b269bd0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C020.jpg
// module id = 303
// module chunks = 0